import {Style,Icon} from 'ol/style';
import {Vector as VectorLayer} from 'ol/layer';
import VectorSource from 'ol/source/Vector';
import TopoJSON from 'ol/format/TopoJSON';
const shoppingMarketPoiStyle = 
  new Style({
    image: new Icon({
      anchor: [0.5, 46],
      anchorXUnits: 'fraction',
      anchorYUnits: 'pixels',
      src: 'data/icons/24px/shopppingmarket.png',
      color: '#F9844A',
      scale: 0.7
    }),
});

export const poiShoppingMarketLayer = new VectorLayer({
  source: new VectorSource({
    url: 'data/india/UP/point_of_interest_SHPMKT.json',
    format: new TopoJSON({
      layers: ['SHPMKT'],
    }),
    overlaps: true,
  }),
  //minZoom: POI_MIN_ZOOM_LEVEL,
  style: shoppingMarketPoiStyle,
  visible: true,
  zIndex : 2
});
